export default __webpack_public_path__ + "atomic/_patterns/02-molecules/doughnut-chart/_doughnut-chart.twig";